<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#info" @click="activeComponent='tabInfo'"><i class="fa fa-circle-info"></i>Info</a></li>
        <li v-if="site.type !== 'redirect'"><a class="nav-link" data-toggle="tab" href="#content" @click="activeComponent='tabContent'"><i class="fa fa-file"></i>  Content</a></li>
        <li v-if="site.type !== 'redirect'"><a class="nav-link" data-toggle="tab" href="#internal-links" @click="activeComponent='tabLinks'"><i class="fa fa-link"></i>  Internal Links</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#index" @click="activeComponent='tabIndex'"><i class="fas fa-tasks"></i>  Index</a></li>
        <li v-if="site.type !== 'redirect'"><a class="nav-link" data-toggle="tab" href="#build" @click="activeComponent='tabBuild'" v-if="user.admin || user.roles.length"><i class="fas fa-hammer"></i> Build</a></li>
        <li>
          <a class="nav-link" data-toggle="tab" href="#qa" @click="activeComponent='tabQa'"><i class="fas fa-tasks"></i> QA <span v-if="site.qaCheck && site.qaCheck.fails" class="red"> ({{ site.qaCheck.fails }})</span></a>
        </li>
        <li><a class="nav-link" data-toggle="tab" href="#tasks" @click="activeComponent='tabTasks'" v-if="user.admin"><i class="fas fa-tasks"></i> Tasks</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#cluster" @click="activeComponent='tabCluster'" v-if="site.type === 'money'"><i class="fas fa-project-diagram"></i> Cluster</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#page-entity" @click="activeComponent='tabPageEntity'" v-if="site.type === 'money'"><i class="fas fa-magic"></i> Page Entity</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#cloud-flare" @click="activeComponent='tabCloudflare'" v-if="user.admin && site.ipProvider && site.ipProvider.integration === 'cloudflare'"><i class="fas fa-cloud"></i> Cloudflare</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#auto-seo" @click="activeComponent='tabAutoSeo'" v-if="site.services && site.services.autoSeo">
          <i class="fas fa-brain"></i> Auto Seo</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TabInfo from './Tabs/Info'
import TabContent from './Tabs/Content'
import TabBuild from './Tabs/Build'
import TabQa from './Tabs/Qa'
import TabLinks from './Tabs/InternalLinks'
import TabIndex from './Tabs/Index'
import TabCluster from './Tabs/Cluster'
import TabTasks from './Tabs/Tasks'
import TabPageEntity from './Tabs/PageEntity'
import TabCloudflare from './Tabs/Cloudflare'
import TabAutoSeo from './Tabs/AutoSeo.vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      activeComponent: 'tabInfo'
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      site: 'getPbn'
    })
  },
  // mixins: [String],
  components: {
    tabInfo: TabInfo,
    tabContent: TabContent,
    tabBuild: TabBuild,
    tabQa: TabQa,
    tabLinks: TabLinks,
    tabIndex: TabIndex,
    tabCluster: TabCluster,
    tabTasks: TabTasks,
    tabPageEntity: TabPageEntity,
    tabCloudflare: TabCloudflare,
    tabAutoSeo: TabAutoSeo
  },
  mounted () {
    // if (this.$route.hash) {
    //   this.activeComponent = 'tab' + String.methods.ucFirst(this.$route.hash.slice(1))
    //   console.log(this.activeComponent)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Content.vue